import React from "react";
import "antd/dist/antd.css";
import ResetPasswordImage from "../../assets/images/ResetPassword.png";
import { Col, Row } from "@mtm/components";
import Styles from "./ResetPassword.module.scss";

type Props = {
  wandaEmailId: string;
};

const ResetPassword: React.FC<Props> = ({ wandaEmailId }) => {
  return (
    <>
      <div className="container">
        <Row className={Styles.ResetPasswordPosition}>
          <Col span={24} lg={12}>
            <img
              src={ResetPasswordImage}
              alt="ResetPasswordImage"
              className={Styles.ResetPasswordImageWidth}
            />
          </Col>
          <Col lg={1} />
          <Col span={24} lg={11}>
            <div className={Styles.ResetPasswordTextGap}>
              <p>Reset Your Password</p>
              <div className={"subTextFont " + Styles.ResetPasswordIndication}>
                Please check your email{" "}
                <span>{wandaEmailId}</span> for further
                instructions.
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default ResetPassword;
